import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { organization } from "../../config";
import axios from "axios";

export default function FundraiserPublic() {
    const { fid } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/api/fundraisers/${fid}/public`)
            .then(res => setData(res.data))
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, [fid]);

    if (loading) return <p className="text-center mt-5">Loading…</p>;
    if (!data) return <p className="text-center mt-5">Fundraiser not found.</p>;

    const raised = data.total_raised_cents / 100;
    const goal = data.goal_amount_cents / 100;
    const pct = Math.min((raised / goal) * 100, 100);

    if (data.archived) {
        return (
            <div className="container my-5 text-center">
                <h4>This fundraiser is no longer active.</h4>
                <p>
                    <Link to="/" className="small-link" style={{ color: "#2E5D3A" }}>
                        &larr; Back to {organization.shortName} website
                    </Link>
                </p>
            </div>
        );
    }

    return (
        <div className="container my-5" style={{ maxWidth: "700px" }}>
            <div className="text-center mb-2">
                <Link to="/" className="small-link" style={{ color: "#2E5D3A" }}>&larr; {organization.shortName} Website</Link>
            </div>

            <h2 className="mb-3 text-center">{data.title}</h2>
            {data.description && (
                <p className="lead text-center">{data.description}</p>
            )}

            {data.goal_public && (
                <>
                    <div className="progress mb-2" style={{ height: "24px" }}>
                        <div className="progress-bar bg-success" style={{ width: `${pct}%` }}>
                            {pct.toFixed(0)}%
                        </div>
                    </div>

                    <p className="text-center mb-4">
                        <strong>${raised.toFixed(2)}</strong> raised of ${goal.toFixed(2)} <br />
                        {data.donor_count > 0 && (<small className="text-muted">{data.donor_count} donor{data.donor_count !== 1 && "s"}</small>)}
                    </p>
                </>
            )}

            <h5 className="mb-3 text-center">Donate</h5>

            <div className="row justify-content-center">
                {data.price_items.map(pi => (
                    <div key={pi.payment_link_id} className="col-sm-4 col-md-4 col-5 mb-3 text-center">
                        <div className="border rounded p-3 h-100 d-flex flex-column">
                            <strong className="mb-2">{pi.label}</strong>
                            <span className="mb-3">${(pi.amount_cents / 100).toFixed(2)}</span>
                            <Link
                                to={`/fundraisers/${fid}/${pi.price_id}`}
                                className="btn btn-admin mt-auto"
                            >
                                Donate
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
